// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__kc6T5","simple":"index_simple__63po2"};